<template>
  <v-flex 
    fill-height 
    lg12 
    md12>
    <v-card class="fill-height">
      <v-layout 
        column 
        fill-height>
        <v-toolbar 
          flat 
          color="secondary" 
          dense>
          <v-toolbar-title class="primarytext--text">Report mensile</v-toolbar-title>
          <v-spacer/>
        </v-toolbar>

        <v-layout 
          row 
          wrap 
          align-center 
          justify-space-around>
          <v-flex 
            align-self-start 
            shrink 
            pt-3>
            <v-date-picker
              v-model="date"
              :allowed-dates="allowedMonths"
              :max="$moment().format('YYYY-MM')"
              event-color="error"
              type="month"
              color="secondary lighten-1"
              locale="it-IT"
              class="elevation-0"
              @input="showStatistica"
            />
          </v-flex>
          <v-flex 
            v-if="!!date" 
            xs12 
            sm12 
            md12 
            lg8 
            align-self-start>        
            <v-container 
              fluid 
              grid-list-md 
              class="scroll-y">
              <v-layout 
                justify-center 
                align-space-around 
                column>
                <v-subheader class="tree--text title">Richieste totale</v-subheader>
                <v-flex 
                  style="display: flex; justify-content: center" 
                  xs12>
                  <v-flex 
                    style="display: flex; flex-direction: column; align-items: center" 
                    xs12 
                    sm6 
                    md4>
                    <v-progress-circular
                      :rotate="-90"
                      :size="100"
                      :width="20"
                      :value="confermatoTotale * 100 / quantitaTotale"
                      :color="getRandomColor().color"
                    >
                      <v-icon 
                        size="40" 
                        color="tree">fa-euro-sign</v-icon>
                    </v-progress-circular>
                    <v-flex class="ml-2 text-truncate">
                      <div class="body-1">Quantità:<span class="body-2 ml-2">{{ quantitaTotale }}</span></div>
                      <div class="body-1">Confermato:<span class="body-2 ml-2">{{ confermatoTotale }}</span></div>
                      <div class="body-1">Importo:<span class="body-2 ml-2">{{ importoTotale }} €</span></div> 
                    </v-flex>
                  </v-flex>
                </v-flex>
                <v-divider/>
                <v-subheader class="tree--text font-weight-regular font-italic">Dettaglio</v-subheader>
                <v-tabs-items
                  v-model="active"
                >
                  <v-tab-item
                    :key="1"
                    :value="1"
                  >
                    <v-flex 
                      ref="dettaglio"
                      style="display: flex; flex-wrap: wrap" 
                      xs12>
                      <template v-for="stat in richiesteStatistica">
                        <v-flex 
                          :key="stat.descrizione"
                          style="display: flex;" 
                          xs12 
                          sm6 
                          md4 
                          @click="showDettaglio(stat)">
                          <v-progress-circular
                            :rotate="-90"
                            :size="100"
                            :width="15"
                            :value="stat.value"
                            :color="getRandomColor().color"
                          >
                            <v-icon 
                              size="40" 
                              color="tree">{{ stat.icon }}</v-icon>
                          </v-progress-circular>
                          <v-flex class="ml-2 text-truncate">
                            <div class="subheading tree--text text-truncate mb-2">{{ stat.descrizione.toUpperCase() }}</div>
                            <div class="body-1">Totale:<span class="body-2 ml-2">{{ stat.quantita }}</span></div>
                            <div class="body-1">Confermato:<span class="body-2 ml-2">{{ stat.confermato }}</span></div>
                            <div class="body-1">Importo:<span class="body-2 ml-2">{{ stat.importo_totale }} €</span></div> 
                          </v-flex>
                        </v-flex>
                      </template>
                    </v-flex>
                  </v-tab-item>
                  <v-tab-item
                    :key="2"
                    :value="2">
                    <v-flex 
                      style="display: flex;
                            flex-direction: column;
                            align-items: center;">
                      <v-toolbar 
                        flat 
                        dense
                        color="transparent">
                        <v-btn 
                          icon 
                          @click="active = 1">
                          <v-icon>arrow_back</v-icon>
                        </v-btn>
                        <v-spacer/>
                        <v-toolbar-title v-if="richiesteStatisticaDettaglio[0]">
                          <v-icon 
                            size="40" 
                            left
                            color="tree">{{ richiesteStatisticaDettaglio[0].icon }}</v-icon>
                        </v-toolbar-title>
                        <v-spacer/>
                      </v-toolbar>
                      <v-list 
                        one-line 
                        style="min-width: 300px">
                        <template v-for="(item, index) in richiesteStatisticaDettaglio">
                          <v-list-tile
                            :key="'list-' + index">
                            <v-list-tile-content class="caption">
                              <v-list-tile-title >{{ item.data | FormatDate }}</v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-content class="caption">
                              <v-list-tile-title >{{ item.importo }} €</v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                              <v-icon 
                                v-if="item.stato == 1" 
                                small 
                                color="success">fa-check</v-icon>
                              <v-icon 
                                v-else-if="item.stato == 2 || item.stato == 5" 
                                small 
                                color="error">fa-times</v-icon>
                              <v-icon 
                                v-else 
                                small 
                                color="amber">fa-sync</v-icon>
                            </v-list-tile-action>
                          </v-list-tile>
                          <v-divider
                            v-if="richiesteStatisticaDettaglio.lenght - 1 !== index"
                            :key="'divider-' + index"/>
                        </template>
                      </v-list>
                    </v-flex>
                  </v-tab-item>
                </v-tabs-items>
              </v-layout>
            </v-container>
          </v-flex>
          <v-flex
            v-else
            xs12
            sm8
            md8
            lg8
            align-self-center
            class="title font-weight-light grey--text pa-3 text-xs-center"
          >Seleziona il mese delle spese!</v-flex>
        </v-layout>
      </v-layout>
    </v-card>      
  </v-flex>
</template>

<script>
import moment from 'moment'
import { mapState, mapActions } from "vuex";
import { getRandomColor } from '../utils/helper'

export default {
  name: "AccDettaglioNote",
  components: {
  },
  filters: {
    FormatDate(val) {
      return moment(val).format('DD/MM/YYYY')
    }
  },
  props: {},
  data: () => ({
    date: null,
    active: 1
  }),
  computed: {
    ...mapState("notaSpese", ["richiesteMensile", "loading", "richiesteStatistica", 'richiesteStatisticaDettaglio']),
    quantitaTotale () {
      return this.richiesteStatistica.map(r => +r.quantita).reduce((acc, r) => acc + r, 0)
    },
    importoTotale () {
      return this.richiesteStatistica.map(r => +r.importo_totale).reduce((acc, r) => acc + r, 0)
    },
    confermatoTotale () {
      return this.richiesteStatistica.map(r => +r.confermato).reduce((acc, r) => acc + r, 0)
    },
  },
  watch: {
    date() {
      this.active = 1
    }
  },
  created() {
      this.getAllRichiesteMensile();
  },
  methods: {
    ...mapActions("notaSpese", ["getAllRichiesteMensile", 'showStatistica', 'showStatisticaDettaglio']),
    getRandomColor,
    allowedMonths (val) {
      return this.richiesteMensile.includes(val)
    },
    showDettaglio (item) {
      return this.showStatisticaDettaglio({
        data: this.date,
        categoria: item.descrizione
      }).then(r => {
        if (r)
          this.active = 2
      })
    },
  }
};
</script>

<style>
/*@import './template/accueil/css/main.css';*/
</style>



// WEBPACK FOOTER //
// modules/Home/views/src/components/TabReport.vue